var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '@lit-labs/virtualizer';
import { virtualize } from '@lit-labs/virtualizer/virtualize.js';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { when } from 'lit/directives/when.js';
import { emit } from '../../internal/event.js';
import styles from './Table.styles.js';
/**
 * @since 0.1
 * @status in-work
 *
 */
export class SgdfTable extends LitElement {
    constructor() {
        super(...arguments);
        this.columns = [];
        this.data = [];
        this.skeleton = false;
        this.noResult = false;
    }
    onTableClick(e, lineIndex) {
        if (!e.defaultPrevented) {
            const currentLine = this.data[lineIndex];
            emit(this, 'sgdf-table:click', { detail: currentLine });
        }
    }
    onRangeChange(rangeEvent) {
        if (!this.noResult && this.pageSize) {
            const loadedData = this.data.length;
            if (loadedData < this.pageSize) {
                // do nothing all datas already loaded
                return;
            }
            if (loadedData <= rangeEvent.last + this.pageSize) {
                emit(this, 'sgdf-table:load-next');
            }
        }
    }
    render() {
        return html `
            <div role="table" class="table">
                <div>
                    <div role="row" class="row">
                        ${this.columns.map(column => html `
                                <div role="columnheader" colspan="1" class="th">
                                    ${column.title}
                                </div>
                            `)}
                    </div>
                </div>
                <div>
                    <div class="tbody" @rangeChanged=${this.onRangeChange}>
                        ${this.data.length === 0
            ? html `<div class="no-data">
                                      <span>${this.noDataMessage}</span>
                                  </div>`
            : virtualize({
                // scroller: true,
                items: this.data,
                renderItem: (line, i) => html `
                                          <div
                                              class="row-container"
                                              @click=${(e) => this.onTableClick(e, i)}
                                              style=${`background: ${!this.skeleton && i % 2 === 0
                    ? 'rgba(0, 58, 93, 0.3)'
                    : 'white'}`}
                                          >
                                              <div role="row" class="tr">
                                                  ${this.columns.map(col => html `
                                                          <div
                                                              role="cell"
                                                              class="td"
                                                          >
                                                              ${when(!!col.render, () => col.render(line[col
                    .field_name], line), () => html `
                                                                      <div
                                                                          class=${classMap({
                    'cell-text': !this
                        .skeleton,
                    loading: this
                        .skeleton,
                })}
                                                                          title=${line[col
                    .field_name]}
                                                                      >
                                                                          ${when(this
                    .skeleton, () => html `
                                                                                  <div
                                                                                      class="bar"
                                                                                  ></div>
                                                                              `, () => html ` ${line[col
                    .field_name]}`)}
                                                                      </div>
                                                                  `)}
                                                          </div>
                                                      `)}
                                              </div>
                                          </div>
                                      `,
            })}
                    </div>
                </div>
            </div>
        `;
    }
}
SgdfTable.styles = styles;
__decorate([
    property({ reflect: true })
], SgdfTable.prototype, "onClick", void 0);
__decorate([
    property({ type: Array })
], SgdfTable.prototype, "columns", void 0);
__decorate([
    property({ type: Array })
], SgdfTable.prototype, "data", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTable.prototype, "skeleton", void 0);
__decorate([
    property({ type: Number })
], SgdfTable.prototype, "pageSize", void 0);
__decorate([
    property({ type: String })
], SgdfTable.prototype, "noDataMessage", void 0);
__decorate([
    property({ type: Boolean })
], SgdfTable.prototype, "noResult", void 0);
__decorate([
    property({ type: Number })
], SgdfTable.prototype, "tableWidth", void 0);
//# sourceMappingURL=Table.js.map